import { render, staticRenderFns } from "./invoice-dialog.vue?vue&type=template&id=4c4abdd0&scoped=true"
import script from "./invoice-dialog.vue?vue&type=script&lang=js"
export * from "./invoice-dialog.vue?vue&type=script&lang=js"
import style0 from "./invoice-dialog.vue?vue&type=style&index=0&id=4c4abdd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4abdd0",
  null
  
)

export default component.exports